
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sucursales",
      function () {
        return require("private-next-pages/sucursales.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sucursales"])
      });
    }
  